import Box from '@mui/material/Box';
import { useTranslate } from 'react-admin';
import { get } from 'lodash';
import useGetAvatar from '@/hooks/useGetAvatar';
import { composeUri } from '@/utils/compose';
import { AVATARS } from '@/utils/CONST';
import extractIdFromURI from '@/utils/id';
import ExportLabelValue from '@/components/interventions/export-intervention/common/export-label-value';
import ExportSectionBox from '@/components/interventions/export-intervention/common/export-section-box';

interface ExportInterventionClientSectionProps {
    clientId: string;
    placeId: string;
}

const ExportInterventionClientSection = ({ clientId, placeId }: ExportInterventionClientSectionProps) => {
    const translate = useTranslate();

    const { avatar: client, isLoading: isLoadingClient } = useGetAvatar({ avatarUriId: composeUri(AVATARS, clientId) });
    const { avatar: place, isLoading: isLoadingPlace } = useGetAvatar({
        avatarUriId: composeUri(AVATARS, placeId),
        filters: {
            'serialization_groups[2]': 'read_avatar_parent',
        },
    });

    const parentId = get(place, 'parent.@id');
    const siteId = parentId ? extractIdFromURI(parentId as string) : undefined;
    const { avatar: site, isLoading: isLoadingSite } = useGetAvatar({
        avatarUriId: siteId ? composeUri(AVATARS, siteId) : undefined,
    });

    if (isLoadingClient || isLoadingPlace || isLoadingSite) {
        return null;
    }

    if (!client?.name && !site?.name && !place) {
        return null;
    }

    return (
        <ExportSectionBox title={translate('intervention.export.section.client')}>
            <Box
                sx={{
                    display: 'grid',
                    gap: 1,
                }}
            >
                {client?.name && <ExportLabelValue label={translate('intervention.export.labels.client')} value={client?.name} />}

                {site?.name && (
                    <ExportLabelValue
                        label={translate('intervention.export.labels.site')}
                        value={`${site?.name ?? ''}${site?.postalCode ? ` - ${site.postalCode}` : ''}${site?.city ? ` - ${site.city}` : ''}`}
                    />
                )}

                {place && (
                    <ExportLabelValue
                        label={translate('intervention.export.labels.place')}
                        value={`${place?.name ?? ''}${place?.postalCode ? ` - ${place.postalCode}` : ''}${place?.city ? ` - ${place.city}` : ''}`}
                    />
                )}
            </Box>
        </ExportSectionBox>
    );
};

export default ExportInterventionClientSection;

